import Vue from 'vue/dist/vue.js';

const axios = require('axios');

Vue.config.productionTip = false;

export default {
    name: 'contactForm',
    _el: null,
    init() {
        this._els = document.querySelectorAll('[data-contact-form]');
        for (const el of this._els) {
            this.run(el);
        }
    },

    run(element) {
        let regNumber = null;
        let firstName = '';
        let lastName = '';
        let name = '';
        let email = '';
        let phone = '';
        let message = '';

        const queryString = window.location.search;
        if (queryString.search('test=contact') != -1) {
            name = 'Ola Nordmann';
            firstName = 'Ola';
            lastName = 'Nordmann';
            email = 'test@example.com';
            phone = '12345679';
            message = 'Test :-)';
        }

        // const subjectMap = {
        //     'service': 'Verkstedbestilling',
        //     'estimation': 'Prisantydning',
        //     'campaign': 'Kampanje',
        //     'accessoires': 'Utstyr & tilbehør',
        //     'caravans': 'Spørsmål om bobil',
        //     'caravan_trailers': 'Spørsmål om campingvogn',
        //     'spare_parts': 'Spørsmål om deler',
        // }

        new Vue({
            el: element,
            delimiters: ['@{', '}'],
            data: {
                a: 'contact form',
                currentRetailer: null,
                firstName: firstName,
                formType: '',
                gdpr: null,
                product: null,
                host: '',
                honeypot: false,
                lastName: lastName,
                name: name,
                retailerId: '',
                redirect: '',
                newsletter: null,
                userId: email,
                email: '',
                phone: phone,
                message: message,
                retailers: [],
                reg_number: null,
                responseStatus: null,
                responseMessage: null,
                subject: '',
                type: '',
                // subjectMap: subjectMap,
                xhrActive: false,
            },

            created() {
                this.host = document.querySelector('[name="site_root"]').content;
                this.redirect = window.location.href;
                element.querySelector('.contact-form').classList.add('is-ready');

                if (element.dataset.product && typeof element.dataset.product === 'string') {
                    this.product = JSON.parse(element.dataset.product);
                }

                if (element.dataset.retailers && typeof element.dataset.retailers === 'string') {
                    this.retailers = JSON.parse(element.dataset.retailers);
                }

                // this.setFormType();
                this.subject = this.getSubject();
                this.retailerId = this.getRetailerId();
                this.setCurrentRetailer();
            },

            methods:
                {
                    setCurrentRetailer() {
                        const retailer = this.retailers.filter(r => r.id == this.retailerId);

                        if (typeof retailer === 'object' && typeof retailer[0] === 'object') {
                            this.currentRetailer = retailer[0];
                        }
                    },
                    // setFormType() {
                    //     // let formType = element.dataset.formtype;
                    //     // let isString = typeof formType === 'string';
                    //     // let hasLength = formType;
                    //     // if (event) {
                    //     // this.formType = event.target.value;
                    //     // return;
                    //     // }
                    //
                    //     this.formType = this.type;
                    // },

                    // getFormType() {
                    //     return this.formType;
                    // },

                    getSubject() {
                        // let formType = this.getFormType();
                        if (this.product) {
                            return this.product.title + ' (' + this.product.year + ')';
                        } else if (element.dataset.subject) {
                            return element.dataset.subject;
                        }
                    },

                    getRetailerId() {
                        if (Number.isInteger(parseInt(this.retailerId))) {
                            return this.retailerId;
                        } else if (typeof element.dataset.retailerid === 'string' && Number.isInteger(parseInt(element.dataset.retailerid))) {
                            return element.dataset.retailerid;
                        } else {
                            return '';
                        }
                    },

                    prepareData() {
                        const token = document.querySelector('[name="CRAFT_CSRF_TOKEN"]');

                        const formType = this.formType ? this.formType : 'general'; // fallback

                        const bodyFormData = new FormData();
                        bodyFormData.append('first_name', this.firstName);
                        bodyFormData.append('last_name', this.lastName);
                        bodyFormData.append('email', this.userId);
                        bodyFormData.append('phone', this.phone);
                        bodyFormData.append('gdpr', this.gdpr);
                        bodyFormData.append('honeypot', document.getElementById('email').value);
                        bodyFormData.append('message', this.message);
                        bodyFormData.append('retailerId', this.getRetailerId());
                        bodyFormData.append('redirect', this.redirect);
                        bodyFormData.append('subject', this.subject);
                        bodyFormData.append('type', formType);
                        bodyFormData.append('reg_number', this.reg_number);

                        if (this.newsletter) {
                            bodyFormData.append('newsletter', '1');
                        }

                        if (this.product) {
                            bodyFormData.append('productId', this.product.id);
                            bodyFormData.append('product', this.product.title);
                            bodyFormData.append('resource', this.product.resource);
                            // bodyFormData.append('type', 'product');
                        }
                        // else {
                        //     bodyFormData.append('type', this.formType);
                        // }

                        return bodyFormData;
                    },

                    onSubmit(event) {
                        this.xhrActive = true;
                        this.setCurrentRetailer();
                        const headers = {"Content-Type": "multipart/form-data"};
                        const postData = this.prepareData();
                        const url = this.host + 'actions/mm/mail/store';

                        axios.post(url, postData, headers)
                            .then(this.onSubmit__callback)
                            .catch(this.onSubmit__error);
                    },

                    onSubmit__callback(response) {
                        if (typeof response === 'object' && typeof response.data === 'object') {
                            this.responseStatus = 'ok';
                            this.responseMessage = response.data.message;
                        }

                        this.xhrActive = false;
                    },

                    onSubmit__error(error) {
                        console.log('onSubmit__error');
                        console.log(error);
                        this.responseStatus = 'error';
                        this.responseMessage = error;
                    }
                }
        });
    }

}